/* Custom pure event delegation & .closest() functions.*/
EventTarget.prototype.delegateListener=function(b,c,d){let a=a=>{let b;[].slice.call(this.querySelectorAll(c)).reverse().filter(b=>b.contains(a.target)).forEach(c=>{(void 0===b|| !1!==b)&&(b=d.call(c,a))})};return this.addEventListener(b,a),a};function closest(a,b){do if(b(a))return a;while(a=a&&a.parentNode)}

window.Custom = window.Custom || {};

(function ($) {
  "use strict";

  
Custom = {
  container: document.querySelector(`body`),

  mobileBreakpoint: "868px",

  init: function() {
    // BASE
    this.setElementHeight();
    this.fontSize();
    this.setScrollAttributes();
    this.localizationPopup();
    this.initImageSizeLogging();

    this.initHeightEqualizer();

    if(document.querySelector('.sticky--button .button')) {
      document.querySelector('.sticky--button .button').addEventListener('click', function () {
        const targetElement = document.querySelector('[type="submit"].product-form__submit');
        console.log(targetElement);
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      });
    }

    this.container.delegateListener("click", "[data-scroll]", function(e) {
      e.preventDefault();
      const targetElement = document.querySelector(e.target.closest("[data-scroll]").getAttribute("data-scroll"));

      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });


    this.container.delegateListener("click", `.cart__checkout-button`, function(e) {
      const termsCheckbox = document.getElementById('terms');
      const termsCheckboxWrapper = document.querySelector('.terms');

      if(termsCheckbox && termsCheckboxWrapper) {
        if (!termsCheckbox.checked) {
          e.preventDefault();
          termsCheckboxWrapper.classList.add("style--error");

          termsCheckboxWrapper.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
          });
        } else {
        }
      }
    });
     
    document.querySelectorAll('[data-trigger], [href="#add"]').forEach(button => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
          let targetSelector = this.getAttribute('data-trigger');
          if(this.getAttribute("href") == "#add") {
            targetSelector = "button[name='add']";
          }
          const targetElement = document.querySelector(targetSelector);

          if (targetElement) {
              targetElement.click();
          }
      });
    });
    
    window.off = Element.prototype.off = function(event) {
      if (!this.namespaces) { return }
      this.removeEventListener(event.split('.')[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
    };
    
    window.on = Element.prototype.on = function(event, callback, options){
      if( !this.namespaces )
        this.namespaces = {};
  
      this.namespaces[event] = callback;
      options = options || false;
  
      this.addEventListener(event.split('.')[0], callback, options);
      return this;
    };
    
    this.iniDropdown();
  },

  
  initHeightEqualizer: function() {
    this.applyHeightEqualization();
    setTimeout(() => {
      this.applyHeightEqualization()
    }, 1500);
    window.addEventListener('resize', () => this.applyHeightEqualization());
  },

  applyHeightEqualization: function() {
    document.querySelectorAll('section').forEach(section => {
      if(section.querySelector(".slider--wrapper")) {
        section.querySelectorAll(".slider--wrapper").forEach(wrapper => {
          this.equalizeHeight(wrapper);
          this.setHeightVariable(wrapper);
        });
      } else {
        this.equalizeHeight(section);
        this.setHeightVariable(section);
      }
    });
  },

  equalizeHeight: function(section) {
    const equalHeightElements = section.querySelectorAll('[data-height="equal"]');
    if (equalHeightElements.length > 0) {
      let maxHeight = 0;
      equalHeightElements.forEach(element => {
        element.style.height = 'auto';
        maxHeight = Math.max(maxHeight, element.offsetHeight);
      });

      if (maxHeight > 20) {
        section.style.setProperty('--element-heights', `${maxHeight}px`);
      }
    }
    

    const equalHeightElements2 = section.querySelectorAll('[data-height="equal2"]');
    if (equalHeightElements2.length > 0) {
      let maxHeight0 = 0;
      equalHeightElements2.forEach(element => {
        element.style.height = 'auto';
        maxHeight0 = Math.max(maxHeight0, element.offsetHeight);
      });

      if (maxHeight0 > 20) {
        section.style.setProperty('--element-heights2', `${maxHeight0}px`);
      }
    }
  },

  setHeightVariable: function(section) {
    const setHeightElement = section.querySelector('[data-height="set"]');
    if (setHeightElement) {
      const height = setHeightElement.offsetHeight;
      // console.log(setHeightElement, height);
      if (height > 20) {
        section.style.setProperty('--element-height', `${height}px`);
      }
    }
  },
  

  
  closeAllPopups: function(current) {
    let popups = document.querySelectorAll(".popup--wrapper");
    popups.forEach((el) => {
      if(el !== current) {
        el.setAttribute("data-active", "false");
      }
      
    });
  },
  
  localizationPopup: function() {
    this.container.delegateListener("click", ".custom-localization button", function(e) {
      e.preventDefault();
      let _this = event.target.closest(".custom-localization");
      let popup = _this.querySelector(".popup--wrapper");
      
      this.closeAllPopups(popup);
      popup.setAttribute("data-active", (popup.getAttribute("data-active") == "false"));
    }.bind(this));

    this.container.delegateListener("click", ".custom-localization .popup--wrapper", function(e) {

      let _this = event.target;
      let popup = _this.closest(".custom-localization").querySelector(".popup--wrapper");

      if(!_this.closest(".popup--inner")) {
        popup.setAttribute("data-active", (popup.getAttribute("data-active") == "false"));
      }
    }.bind(this));
  },
  
  iniDropdown() {
    var selectors = {
      trigger: `[data-dropwdown="trigger"]`,
      module: `[data-dropwdown="body"]`,
      moduleInner: '.dropdown--inner',
      tabs: '.collapsible-trigger--tab'
    };
  
    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height',
      tabs: 'collapsible-trigger--tab'
    };
  
    var namespace = `.list--unset`;
  
    var isTransitioning = false;
  
    var el = document;
    el.querySelectorAll(selectors.trigger).forEach(trigger => {
      var state = trigger.classList.contains(classes.open);
      trigger.setAttribute('aria-expanded', state);
      trigger.off('click' + namespace);
      trigger.on('click' + namespace, toggle);
    });
    
    document.addEventListener("reload_dropdowns", function(event) {
      document.querySelectorAll(selectors.trigger).forEach(trigger => {
          var state = trigger.classList.contains(classes.open);
          trigger.setAttribute('aria-expanded', state);
          trigger.removeEventListener('click', toggle); // Remove previous event listener
          trigger.addEventListener('click', toggle); // Add event listener
      });
    });
    
    function toggle(evt) {
      if (isTransitioning) {
        return;
      }
  
      isTransitioning = true;
  
      var el = evt.currentTarget;
      var isOpen = el.classList.contains(classes.open);
      var isTab = el.classList.contains(classes.tabs);
      var moduleId = el.getAttribute('aria-controls');
      var container = document.getElementById(moduleId);
  
      if (!moduleId) {
        moduleId = el.dataset.controls;
      }
      
      if (!moduleId) {
        return;
      }
      
      if (!container) {
        var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
        if (multipleMatches.length > 0) {
          container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
        }
      }
  
      if (!container) {
        isTransitioning = false;
        return;
      }
  
      var height = container.querySelector(selectors.moduleInner).offsetHeight;
      var isAutoHeight = container.classList.contains(classes.autoHeight);
      var parentCollapsibleEl = container.parentNode.closest(selectors.module);
      var childHeight = height;
  
      if (isTab) {
        if(isOpen) {
          isTransitioning = false;
          return;
        }
  
        var newModule;
        document.querySelectorAll(selectors.tabs + '[data-id="'+ el.dataset.id +'"]').forEach(el => {
          el.classList.remove(classes.open);
          newModule = document.querySelector('#' + el.getAttribute('aria-controls'));
          setTransitionHeight(newModule, 0, true);
        });
      }
      
      if (isOpen && isAutoHeight) {
        setTimeout(function() {
          height = 0;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        }, 0);
      }
  
      if (isOpen && !isAutoHeight) {
        height = 0;
      }
  
      el.setAttribute('aria-expanded', !isOpen);
      if (isOpen) {
        el.classList.remove(classes.open);
        // if(el.querySelector("span").textContent == "Read Less") {
        //   el.classList.remove("hide");
        //   el.querySelector("span").textContent = "Read More";
        // }
      } else {
        el.classList.add(classes.open);
        // if(el.querySelector("span").textContent == "Read More") {
        //   el.classList.add("hide");
        //   el.querySelector("span").textContent = "Read Less";
        // }
      }
  
      setTransitionHeight(container, height, isOpen, isAutoHeight);
      
      if (parentCollapsibleEl) {
        var parentHeight = parentCollapsibleEl.style.height;
  
        if (isOpen && parentHeight === 'auto') {
          childHeight = 0;
        }
  
        var totalHeight = isOpen ? parentCollapsibleEl.offsetHeight - childHeight : height + parentCollapsibleEl.offsetHeight;
  
        setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
      }
    }
  
    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      container.classList.remove(classes.hide);
      prepareTransition(container, function() {
        container.style.height = height+'px';
        if (isOpen) {
          container.classList.remove(classes.open);
        } else {
          container.classList.add(classes.open);
        }
      });
  
      if (!isOpen && isAutoHeight) {
        var o = container;
        window.setTimeout(function() {
          o.css('height','auto');
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }

    function prepareTransition(el, callback) {
      el.addEventListener('transitionend', removeClass);
  
      function removeClass(evt) {
        el.classList.remove('is-transitioning');
        el.removeEventListener('transitionend', removeClass);
      }
  
      el.classList.add('is-transitioning');
      el.offsetWidth;
  
      if (typeof callback === 'function') {
        callback();
      }
    }
  },
  
  getDistanceToParentBottom : function(element) {
    let elementRect = element.getBoundingClientRect();
    let parentRect = element.parentElement.getBoundingClientRect();
    let distanceToParentBottom = parentRect.bottom - elementRect.bottom;
    return distanceToParentBottom;
  },
  
  setElementHeight : function() {
    const elementHeight = (event) => {
      document.querySelectorAll("[data-height^='target']").forEach((el) => { 
        let container = el.closest("[data-height='container']");
        let name = el.getAttribute("data-height").split("/")[1];
        if(name) {
          document.documentElement.style.setProperty(`--${ name }`, el.clientHeight + "px");
        } else {
          container.style.setProperty('--element_height', el.clientHeight + 'px');
          if(!container.classList.contains("height-set")) {
            container.classList.add("height-set");
          }
        }
      });
      
    }
    window.addEventListener("resize", elementHeight);
    window.addEventListener("load", elementHeight);
  },

  setScrollAttributes: function() {  
    let lastScrollTop = 0;
    
    const handleScroll = (event) => {
      let currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      this.container.setAttribute("data-scrollDirection", (currentScroll > lastScrollTop ? "down" : "up"));
      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
      
      this.container.setAttribute("data-scrolled", window.scrollY > 0);
      
    };
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("load", handleScroll);
  },

  setStickyElement: function(selector) {
    const elements = document.querySelectorAll(selector);
    let distance;
    
    this.checkScrollPosition(elements, this.header.clientHeight);
    window.addEventListener("scroll", () => {
      this.checkScrollPosition(elements, this.header.clientHeight);
    });
  },

  checkScrollPosition: (elements, header) => {
    let distance;
    let elementHeight;
    
    elements.forEach(function(element) {
      distance = window.pageYOffset + element.getBoundingClientRect().top;
      distance = element.getBoundingClientRect().top - header;
      elementHeight = element.clientHeight;

      element.style.paddingTop = distance <= 0 ? `${ elementHeight }px` : 0;
      element.setAttribute("data-sticky", distance <= 0);
    });
  },

  setInputValue: function(event, callback) {
    let self = event.target;
    let container = self.parentElement;
    let input = container.querySelector("input");
    let min = parseInt(input.getAttribute("min"));
    let current = parseInt(input.value);
    let max = parseInt(input.getAttribute("max"));

    input.value = self.classList.contains("plus") ? (current < max ? current + 1 : max) : (current > min ? current - 1 : min);

    if(self.classList.contains("minus") && current === min) {
      //callback(input.value);
    }

    callback(input.value);
    
    input.dispatchEvent(new Event('input', { 'bubbles': true }));
  },

  handlelize: function(str) {
    str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/([^\w]+|\s+)/g, '-')
      .replace(/\-\-+/g, '-')
      .replace(/(^-+|-+$)/g, '')
      .toLowerCase();
  
    return str
  },

  fontSize: function() {
    function adjustFontSize() {
      const elements = document.querySelectorAll('[data-font]');

      elements.forEach(element => {
        const elementWidth = element.offsetWidth;
        
        const fontData = element.getAttribute('data-font').split('/');
        const baseFontSize = parseFloat(fontData[0]) || 10;
        const baseContainerWidth = parseFloat(fontData[1]) || 1280;
        
        let newFontSize = (elementWidth / baseContainerWidth) * baseFontSize;

        if(newFontSize >= 16) {
          newFontSize = 16;
        }
        element.style.fontSize = newFontSize + 'px';
      });
    }

    window.addEventListener('load', () => {
      adjustFontSize();
      setTimeout(adjustFontSize, 1500);
      setTimeout(adjustFontSize, 3000);
    });
                

    window.addEventListener('resize', adjustFontSize);
  },

  


  initImageSizeLogging: function() {
    const breakpoints = [362, 557, 748, 994, 1203, 1542];
    const widthsCollected = new Map();
    let lastLoggedWidth = null;

    const tryLogAll = () => {
      if (widthsCollected.size === breakpoints.length) {
        const widths = breakpoints.map(bp => widthsCollected.get(bp));
        const min = Math.min(...widths);
        const max = Math.max(...widths);
        const widthsStr = widths.map(w => w.toFixed(2)).join(', ');
        console.log(`${widthsStr}, ${min.toFixed(0)}:${max.toFixed(0)}`);
      }
    };

    window.addEventListener('resize', () => {
      const width = Math.floor(window.innerWidth);
      if (breakpoints.includes(width) && width !== lastLoggedWidth) {
        lastLoggedWidth = width;
        if (window.temp1 instanceof HTMLElement) {
          const renderedWidth = window.temp1.clientWidth;
          widthsCollected.set(width, renderedWidth);
          console.log(`\n[Viewport ${width}px] temp1 rendered size: ${renderedWidth.toFixed(2)}`);
          tryLogAll();
        } else {
          console.log(`\n[Viewport ${width}px] temp1 is not set or not an element.`);
        }
      }
    });

    const initWidth = Math.floor(window.innerWidth);
    if (breakpoints.includes(initWidth) && window.temp1 instanceof HTMLElement) {
      const renderedWidth = window.temp1.clientWidth;
      widthsCollected.set(initWidth, renderedWidth);
      console.log(`\n[Viewport ${initWidth}px] temp1 rendered size: ${renderedWidth.toFixed(2)}`);
      tryLogAll();
    }
  }
};

Custom.init();

})();

class SliderElement extends HTMLElement {
  async connectedCallback() {
    const isRecentlyViewed = this.dataset.content === "recently_viewed";
    const swiperEl = this.querySelector(".swiper");
    const wrapper = swiperEl.querySelector(".swiper-wrapper");

    
    const settings = this.getAttribute("data-settings");
    const parsedSettings = settings ? JSON.parse(settings) : {};

    let parentSection = this.closest(".swiper--wrapper") || this.closest("section");
    if (this.closest("media-gallery") || this.closest(".media-gallery")) {
      parentSection = this;
    }

    const paginationEl = parentSection?.querySelector(".swiper-pagination") || null;
    const scrollbarEl = parentSection?.querySelector(".swiper-scrollbar") || null;

    const nextButtons = [];
    const prevButtons = [];

    const next1 = parentSection?.querySelector(".swiper-button-next");
    const prev1 = parentSection?.querySelector(".swiper-button-prev");
    const next2 = parentSection?.querySelector(".swiper-button-next2");
    const prev2 = parentSection?.querySelector(".swiper-button-prev2");

    if (next1 && prev1) {
      nextButtons.push(next1);
      prevButtons.push(prev1);
    }

    if (next2 && prev2) {
      nextButtons.push(next2);
      prevButtons.push(prev2);
    }

    const defaultSettings = {
      loop: false,
      spaceBetween: 10,
      navigation: {
        nextEl: nextButtons,
        prevEl: prevButtons,
      },
    };

    if (paginationEl) {
      defaultSettings.pagination = {
        el: paginationEl,
        clickable: true,
      };
    }

    if(parsedSettings.thumbs) {
      parsedSettings.thumbs.swiper = this.closest('section').querySelector(".slider-thumbs .swiper");
    }
    
    if (scrollbarEl) {
      defaultSettings.scrollbar = {
        el: scrollbarEl,
        draggable: true,
      };
    }

    const swiperSettings = { ...defaultSettings, ...parsedSettings };

    if (isRecentlyViewed) {
      this.querySelector(".swiper-wrapper").classList.add("style--sectionLoading");
      const STORAGE_KEY = "recently_viewed_products";
      const stored = localStorage.getItem(STORAGE_KEY);
      const skus = stored ? JSON.parse(stored) : [];

      if (skus.length) {
        // const query = skus.map(sku => `"${sku}"`).join("+OR+");
        // const url = `/search?type=product&q=${query}&options%5Bprefix%5D=last&view=dynamic_slides`.replaceAll("#", "");

        const query = skus.map(sku => encodeURIComponent(sku)).join("+OR+");
        const url = `/search?type=product&q=${query}&options%5Bprefix%5D=last&view=dynamic_slides`;
    console.log(url);
        try {
          const response = await fetch(url);
          const html = await response.text();

          const temp = document.createElement("div");
          temp.innerHTML = html;

          const slides = temp.querySelectorAll(".swiper-slide");

          wrapper.innerHTML = "";

          slides.forEach((slide, index) => {
            wrapper.appendChild(slide);
          });

          this.swiper = new Swiper(swiperEl, swiperSettings);

        } catch (error) {
          console.error("Recently viewed fetch error:", error);
        }
      }


    } else {
      this.swiper = new Swiper(swiperEl, swiperSettings);
      if (this.getAttribute("data-filters") === "true") {
        this.initFilters();
      }
    }




    // this.swiper = new Swiper(swiperEl, swiperSettings);
  }

    initFilters() {
      const swiper = this.swiper;
      const section = this.closest("section");

      const mainButton = section?.querySelector("[data-button] a");
      const filterButtons = section?.querySelectorAll("[data-filter]");
      const source = section?.querySelector(".swiper-source");

      if (!swiper || !source || !filterButtons?.length) return;

      const allSlides = Array.from(source.children);

      const applyFilter = (type, url, title) => {
        swiper.loopDestroy();
        swiper.removeAllSlides();

        const filteredSlides = allSlides.filter(slide => {
          return type === "all" || slide.dataset.type === type;
        });

        filteredSlides.forEach(slide => {
          swiper.appendSlide(slide.cloneNode(true));
        });

        swiper.update();
        swiper.loopCreate();
        
        swiper.slideToLoop(0, 0);
        swiper.update();

        if (mainButton) {
          mainButton.href = url;
          mainButton.textContent = title;
        }
      };

      filterButtons.forEach(btn => {
        btn.addEventListener("click", () => {
          const type = btn.dataset.filter;
          const url = btn.dataset.url;
          const title = btn.dataset.title;

          filterButtons.forEach(b => b.classList.remove("active"));
          btn.classList.add("active");

          applyFilter(type, url, title);
        });
      });

      const initial =
        section.querySelector("[data-filter].active") || filterButtons[0];

      if (initial) initial.click();
    }
}

customElements.define('slider-element', SliderElement);

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-snippet='tooltip']").forEach(tooltipWrapper => {
    tooltipWrapper.addEventListener("mouseenter", () => 
      tooltipWrapper.setAttribute("data-active", "true")
    );

    tooltipWrapper.addEventListener("mouseleave", () => 
      tooltipWrapper.removeAttribute("data-active")
    );
  });
});

class BGGIntegration extends HTMLElement {
  static cache = {};
  static requestQueue = [];
  static isRequesting = false;

  connectedCallback() {
    const id = this.getAttribute("data-id");
    this.ratingElement = this.querySelector("span");

    if (!id || !this.ratingElement) return;

    this.loadGameRating(id);
  }

  async loadGameRating(gameId) {
    let ratings = this.getStoredRatings();

    if (ratings[gameId]) {
      this.ratingElement.textContent = ratings[gameId];
      this.ratingElement.classList.add("visible");
      return;
    }

    if (BGGIntegration.cache[gameId]) {
      this.ratingElement.textContent = BGGIntegration.cache[gameId];
      this.ratingElement.classList.add("visible");
      return;
    }

    BGGIntegration.requestQueue.push({ gameId, element: this });

    if (!BGGIntegration.isRequesting) {
      this.processQueue();
    }
  }

  async processQueue() {
    if (BGGIntegration.requestQueue.length === 0) {
      BGGIntegration.isRequesting = false;
      return;
    }

    BGGIntegration.isRequesting = true;
    const { gameId, element } = BGGIntegration.requestQueue.shift();

    const rating = await element.fetchGameRating(gameId);


    console.log(rating);
    if (rating) {
      element.ratingElement.textContent = rating;
      this.ratingElement.classList.add("visible");
      let ratings = element.getStoredRatings();
      ratings[gameId] = rating;
      element.saveRatings(ratings);
      BGGIntegration.cache[gameId] = rating;
    } else {
      element.parentElement.classList.add("hide");
       if(!document.querySelector('.element-icons > div:not(.hide)')) {
        document.querySelector('.element-icons').classList.add("hide");
       }
    }

    setTimeout(() => {
      element.processQueue();
    }, 5000);
  }

  async fetchGameRating(gameId) {
    const proxyUrl = `https://api.allorigins.win/get?url=${encodeURIComponent(`https://boardgamegeek.com/xmlapi/boardgame/${gameId}&stats=1`)}`;

    try {
      const response = await fetch(proxyUrl);
      const data = await response.json();

      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(data.contents, "text/xml");

      const averageRating = xmlDoc.querySelector("statistics ratings average")?.textContent;
      return averageRating ? parseFloat(averageRating).toFixed(1) : null;
    } catch (error) {
      console.error("Error fetching game data:", error);
      return null;
    }
  }

  getStoredRatings() {
    try {
      return JSON.parse(localStorage.getItem("bgg_ratings")) || {};
    } catch {
      return {};
    }
  }

  saveRatings(ratings) {
    localStorage.setItem("bgg_ratings", JSON.stringify(ratings));
  }
}

customElements.define("bgg-integration", BGGIntegration);

class CartButton extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener("click", this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.handleClick);
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-all"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  handleClick(event) {
    const btn = event.target;
    
    if (!btn) return;

    const id = this.dataset.id;

    const formData = {
      items: [{ id, quantity: 1 }],
      sections: "cart-data"
    };

    formData.sections = this.getSectionsToRender().map((section) => section.id);

    btn.classList.add("button--loading");

    this.cartAdd(formData, btn, id);
  }

  cartAdd(formData, btn, id) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    })
      .then(res => res.json())
      .then(response => {
        document.querySelector("cart-notification").renderContents(response);
      })
      .finally(() => btn.classList.remove("button--loading"));
  }
}
customElements.define("cart-button", CartButton);

class UpsellButton extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.cartPage = !!document.querySelector('[data-template="cart"]');
  }

  connectedCallback() {
    this.addEventListener("click", this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.handleClick);
  }

  getSectionsToRender() {
    if (this.cartPage) {
      return [
        {
          id: "alternate-cart-items",
          section: document.getElementById("main-cart-items")?.dataset.id,
          selector: ".js-contents-items",
        },
        {
          id: "cart-icon-bubble",
          selector: ".shopify-section",
          section: "cart-icon-bubble",
        },
      ];
    }

    return [
      {
        id: "cart-notification-product",
        selector: `[id="cart-notification-product-all"]`,
      },
      { id: "cart-notification-button" },
      { id: "cart-icon-bubble" },
    ];
  }

  handleClick(event) {
    const btn = event.currentTarget;
    if (!btn) return;

    const id = this.dataset.id;
    if (!id) return;

    const sections = this.getSectionsToRender();

    const formData = {
      items: [{ id, quantity: 1 }],
      sections: sections.map((s) => s.id),
    };

    btn.classList.add("button--loading");
    this.cartAdd(formData, btn, sections);
  }

  parseHTML(html) {
    return new DOMParser().parseFromString(html, "text/html");
  }

  cartAdd(formData, btn, sections) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((response) => {
        if (!this.cartPage) {
          document.querySelector("cart-notification")?.renderContents(response);
          return;
        }

        sections.forEach((section) => {
          const html = response.sections?.[section.id];
          if (!html) return;

          const parsedDoc = this.parseHTML(html);
          const targetId = section.id === "alternate-cart-items" ? "main-cart-items" : section.id;

          const container = document.getElementById(targetId);
          if (!container) return;

          const sourceEl = section.selector ? parsedDoc.querySelector(section.selector) : parsedDoc.body;
          if (!sourceEl) return;

          const newContent = sourceEl.innerHTML;

          if (targetId === "main-cart-items" && newContent.trim().length < 50) {
            document.querySelector(".cart-container")?.classList.add("is-empty");
          }

          if (section.multiple && section.selector) {
            document.querySelectorAll(section.selector).forEach((el) => {el.innerHTML = newContent;});
          } else {
            const targetEl = section.selector ? container.querySelector(section.selector) : container;
            if (targetEl) targetEl.innerHTML = newContent;
          }

          if (targetId === "main-cart-items") {
            document.querySelectorAll("[data-update]").forEach((el) => {
              const key = el.dataset.update;
              const updatedEl = parsedDoc.querySelector(`[data-update="${key}"]`);

              if (updatedEl) {
                el.innerHTML = updatedEl.innerHTML;
              }
            });
          }
        });
      })
      .catch((err) => {
        console.error("Cart update failed:", err);
      })
      .finally(() => {
        btn.classList.remove("button--loading");
      });
  }
}

customElements.define("upsell-button", UpsellButton);

class DynamicProducts extends HTMLElement {
  constructor() {
    super();
    this.debounceTimer = null;
    this.cache = new Map();
    this.type = "sku"
    this.debouncedLoadContent = debounce(this.loadContent.bind(this), 200);
  }
   
  connectedCallback() {
    this.ids = this.getAttribute("data-content");
    this.container = this.querySelector(".container");
    this.loadContent();
  }

  async loadContent() {
    if (!this.container || !this.ids) {
      console.error("Missing Data");
      return;
    }
    
    if (this.cache.has(this.ids)) {
      this.container.innerHTML = this.cache.get(this.ids);
      return;
    }
    
    const query = this.ids.split(",").map(item => encodeURIComponent(`"${item.trim()}"`)).join("+OR+");
    const fetchUrl = `/search?q=${query}&view=dynamic`;

    try {
      const response = await fetch(fetchUrl);
      if (response.ok) {
        const html = await response.text();
        this.cache.set(this.ids, html);
        this.container.innerHTML = html;
      } else {
        console.error("Failed to fetch slider content:", response.status);
      }
    } catch (error) {
      console.error("Error fetching slider content:", error);
    }
  }

  static get observedAttributes() {
    return ['data-content'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-content' && oldValue !== newValue) {
      this.ids = newValue;
      this.debouncedLoadContent();
    }
  }
  
  refresh() {
    this.debouncedLoadContent();
  }

  disconnectedCallback() {
    clearTimeout(this.debounceTimer);
  }
}
customElements.define("dynamic-products", DynamicProducts);

class DropdownElement extends HTMLElement {
  connectedCallback() {
    this.init();
  }

  init() {
    Element.prototype.on = function (event, callback, options = false) {
      if (!this._eventNamespaces) {
        this._eventNamespaces = {};
      }
      this._eventNamespaces[event] = callback;
      this.addEventListener(event.split(".")[0], callback, options);
      return this;
    };

    Element.prototype.off = function (event) {
      if (!this._eventNamespaces) return;
      const callback = this._eventNamespaces[event];
      if (callback) {
        this.removeEventListener(event.split(".")[0], callback);
        delete this._eventNamespaces[event];
      }
      return this;
    };

    this.cleanupText();
    this.initializeDropdown();
  }

  cleanupText() {
    const paragraphs = this.querySelectorAll(".dropdown--inner p");
    paragraphs.forEach((paragraph) => {
      // paragraph.childNodes.forEach((child) => {
      //   if (child.nodeType === Node.TEXT_NODE) {
      //     child.textContent = child.textContent.trim().replace(/\s+/g, " ");
      //   }
      // });
      
      if(paragraph.textContent === "") {
        paragraph.remove();
      }
    });

    // if (this.querySelector(".dropdown--inner").textContent.trim() === "") {
    //   this.classList.add("hide");
    // }
  }

  initializeDropdown() {
    const selectors = {
      trigger: '[data-dropwdown="trigger0"]',
      body: '[data-dropwdown="body0"]',
      inner: ".dropdown--inner",
    };

    const classes = {
      open: "is-open",
      transitioning: "is-transitioning",
    };

    let isTransitioning = false;

    const triggers = this.querySelectorAll(selectors.trigger);
    triggers.forEach((trigger) => {
      const state = trigger.classList.contains(classes.open);
      trigger.setAttribute("aria-expanded", state);

      trigger.off("click.dropdown");
      trigger.on("click.dropdown", (evt) => this.toggleDropdown(evt, selectors, classes, isTransitioning));
    });
  }

  toggleDropdown(evt, selectors, classes, isTransitioning) {
    if (isTransitioning) return;

    isTransitioning = true;

    const trigger = evt.currentTarget;
    const isOpen = trigger.classList.contains(classes.open);
    const bodyId = trigger.getAttribute("aria-controls");
    const body = this.querySelector(`#${bodyId}`);

    console.log("toggleDropdown");
    if (!body) {
      isTransitioning = false;
      return;
    }

    const contentHeight = body.querySelector(selectors.inner).offsetHeight;

    if (isOpen) {
      body.style.height = `${contentHeight}px`;
      requestAnimationFrame(() => {
        body.style.height = "0";
      });
    } else {
      body.style.height = "0";
      requestAnimationFrame(() => {
        body.style.height = `${contentHeight}px`;
      });
    }

    body.addEventListener(
      "transitionend",
      () => {
        body.style.height = isOpen ? "0" : "auto";
        body.classList.toggle(classes.open, !isOpen);
        isTransitioning = false;
      },
      { once: true }
    );

    const labelContainer = trigger.querySelector(`[data-labels]`);
    if(labelContainer) {
      const labels = labelContainer.dataset.labels.split("/");
      labelContainer.textContent = labels[0] === labelContainer.textContent.trim() ? labels[1] : labels[0] ;
    }

    trigger.setAttribute("aria-expanded", !isOpen);
    trigger.classList.toggle(classes.open, !isOpen);
  }
}
customElements.define("dropdown-element", DropdownElement);

class DualRange extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });

    this.shadowRoot.innerHTML = `
      <style>
        :host{display:block;--track-height:6px;--thumb-size:20px;--range-color:#5D798E;--track-color:#B8C6D0}
        .wrap{position:relative;height:var(--thumb-size);margin:0}
        input[type=range]{margin:0;position:absolute;left:0;right:0;top:50%;transform:translateY(-50%);height:var(--thumb-size);background:transparent;pointer-events:none;-webkit-appearance:none}
        input[type=range]::-webkit-slider-thumb{pointer-events:auto;-webkit-appearance:none;width:var(--thumb-size);height:var(--thumb-size);border-radius:50%;background:var(--range-color);border:2px solid var(--range-color)}
        .track{position:absolute;left:0;right:0;top:50%;transform:translateY(-50%);height:var(--track-height);background:var(--track-color);border-radius:999px}
        .fill{position:absolute;height:var(--track-height);background:var(--range-color);top:50%;transform:translateY(-50%);border-radius:999px}
      </style>
      <div class="wrap">
        <div class="track"></div>
        <div class="fill"></div>
        <input id="min" type="range" />
        <input id="max" type="range" />
      </div>
    `;
  }

  connectedCallback() {
    this.minR = this.shadowRoot.querySelector('#min');
    this.maxR = this.shadowRoot.querySelector('#max');
    this.fill = this.shadowRoot.querySelector('.fill');

    this.minR.min = 0;
    this.minR.max = 100;
    this.maxR.min = 0;
    this.maxR.max = 100;

    // Domain (real values)
    this.domainMin = Number(this.getAttribute('value-min') || 0);
    this.domainMax = Number(this.getAttribute('value-max') || 100);

    // Current real values
    this.currentMin = Number(this.dataset.currentMin ?? this.domainMin);
    this.currentMax = Number(this.dataset.currentMax ?? this.domainMax);

    // Map real → percent
    this.minR.value = Math.round(
      ((this.currentMin - this.domainMin) /
        (this.domainMax - this.domainMin)) * 100
    );

    this.maxR.value = Math.round(
      ((this.currentMax - this.domainMin) /
        (this.domainMax - this.domainMin)) * 100
    );

    const update = () => {
      let a = Number(this.minR.value);
      let b = Number(this.maxR.value);

      if (a > b) [a, b] = [b, a];

      this.minR.value = a;
      this.maxR.value = b;

      // Visualy
      this.fill.style.left = a + '%';
      this.fill.style.width = (b - a) + '%';


      // Real values
      const realMin = Math.round(
        this.domainMin +
          (this.domainMax - this.domainMin) * (a / 100)
      );

      const realMax = Math.round(
        this.domainMin +
          (this.domainMax - this.domainMin) * (b / 100)
      );

      this.vmin = realMin;
      this.vmax = realMax;

      this.dispatchEvent(
        new CustomEvent('change', {
          detail: { min: realMin, max: realMax }, bubbles: true,composed: true
        })
      );
    };

    this.minR.addEventListener('input', update);
    this.maxR.addEventListener('input', update);

    update();
  }

  get values() {
    return {
      min: this.vmin,
      max: this.vmax
    };
  }
}
customElements.define('dual-range', DualRange);

class CustomInstagramSection extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const wrapper = this.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    const feed = document.querySelector('#insta-feed');
    if (feed) feed.style.display = 'none'; // hide app section immediately

    // Initial attempt to grab any existing images
    const imgs = document.querySelectorAll('#insta-feed .instafeed-new-layout-item > .instafeed-lazy-image');
    // if (imgs.length) this.buildSlider(imgs);

    // Observe the feed for newly added Instagram items
    this.observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (!(node instanceof HTMLElement)) return;
          if (node.classList.contains("instafeed-new-layout-container")) {
            // this.buildSlider([lazyImg]);
            this.buildSlider(document.querySelectorAll('#insta-feed .instafeed-new-layout-item > .instafeed-lazy-image'));
            this.observer.disconnect();
          }
        });
      });
    });

    if (feed) {
      this.observer.observe(feed, { childList: true, subtree: true });
    }
  }

  buildSlider(appImages) {
    const wrapper = this.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    appImages.forEach(img => {
      const slide = document.createElement('div');
      slide.classList.add('swiper-slide');

      const clone = img.nextElementSibling ? img.nextElementSibling.cloneNode(true) : null;

      slide.innerHTML = `
        <div class="slide--inner select--none">
          <div class="image--wrapper" data-height="equal">
            <img src="${img.dataset.instafeedSrc}" alt="${img.alt || ''}">
          </div>
        </div>
      `;

      const wrapperEl = slide.querySelector('.image--wrapper');
      if (clone) wrapperEl.appendChild(clone);

      wrapper.appendChild(slide);
    });

    setTimeout(() => {
      window.Custom.applyHeightEqualization();
    }, 1500);
    
    setTimeout(() => {
      window.Custom.applyHeightEqualization();
    }, 3000);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }
}

customElements.define('custom-instagram-section', CustomInstagramSection);



class ShoppableImage extends HTMLElement {
  connectedCallback() {
    this.imageWrapper = this.querySelector("[data-shoppable-image-wrapper]");
    this.image        = this.querySelector("[data-shoppable-image-img]");
    this.points       = Array.from(this.querySelectorAll("[data-hotspot]"));
    this.tooltips     = Array.from(this.querySelectorAll("[data-tooltip-wrapper]"));

    this.activeClass  = "shoppable-image__hotspot--active";
    this.tooltipDelay = 300;

    this._listeners        = []; // tracks every addEventListener call for cleanup
    this.hoverTimer        = null;
    this.windowScrollTimer = null;
    this.windowScrollEvent = null;

    this._bindEvents();
  }

  disconnectedCallback() {
    this.onSectionUnload();
  }

  // -------------------------------------------------------------------------
  // Hotspot / tooltip setup
  // -------------------------------------------------------------------------

  _bindEvents() {
    this._positionElements();

    if (this.image) {
      // Reposition once the responsive image finishes loading
      this._on(this.image, "load", () => this._positionElements());
    }

    this._on(this, "touchend", () => this._clearAllActive());

    this.points.forEach((point, i) => {
      const tooltip = this.tooltips[i];

      this._on(point, "click",    (e) => this._setActivePoint(e));
      this._on(point, "touchend", (e) => this._setActivePoint(e));
      this._on(point, "mouseover", (e) => this._setActivePoint(e));
      this._on(point, "mouseout",  (e) => this._closeActivePoint(e));
      this._on(point, "focus",    (e) => this._setActivePoint(e));

      // Hotspots fade/slide in on first paint — once that finishes, switch
      // to the idle pulse animation so it doesn't loop the entrance forever
      this._on(point, "animationend", (e) => {
        if (e.animationName === "slide-fade-y" && e.elapsedTime > 0) {
          point.classList.add("shoppable-image__hotspot--pulse");
          point.classList.remove("pxu-lia-element");
          point.style.animationPlayState = "";
        }
      });

      if (!tooltip) return;

      this._on(tooltip, "touchend", (e) => e.stopPropagation());
      this._on(tooltip, "mouseover", (e) => this._setActivePoint(e));
      this._on(tooltip, "mouseout",  (e) => this._closeActivePoint(e));
      this._on(tooltip, "focus",    (e) => e.stopPropagation());
    });
  }

  _positionElements() {
    this.positionHotspots();
    this.positionTooltips();
  }

  // -------------------------------------------------------------------------
  // Active state
  // -------------------------------------------------------------------------

  _setActivePoint(e) {
    e.stopPropagation();

    const point = e.currentTarget.closest("[data-hotspot]");
    if (!point) return;

    if (this.hoverTimer !== null) {
      clearTimeout(this.hoverTimer);
      this.hoverTimer = null;
    }

    const isActive = point.classList.contains(this.activeClass);

    // Touch: tapping an already-open hotspot closes it
    if (e.type === "touchend" && isActive) {
      point.classList.remove(this.activeClass);
      return;
    }

    // Click: clicking an already-open hotspot does nothing (avoids re-trigger)
    if (e.type === "click" && isActive) return;

    if (!isActive) {
      const activeTooltip = this.querySelector(`.${this.activeClass}`);
      if (activeTooltip) activeTooltip.classList.remove(this.activeClass);

      // Reposition in case the user scrolled or resized since last open
      this.positionTooltips();
      point.classList.add(this.activeClass);
    }
  }

  _closeActivePoint(e) {
    const point = e.currentTarget.closest("[data-hotspot]");
    if (!point) return;

    if (this.hoverTimer !== null) clearTimeout(this.hoverTimer);

    // Debounce close so moving from hotspot to tooltip doesn't flicker it shut
    this.hoverTimer = setTimeout(() => {
      point.classList.remove(this.activeClass);
    }, this.tooltipDelay);
  }

  _clearAllActive() {
    const activeTooltip = this.querySelector(`.${this.activeClass}`);
    if (activeTooltip) activeTooltip.classList.remove(this.activeClass);
  }

  _resetTooltips() {
    this.tooltips.forEach((tooltip) => {
      tooltip.classList.remove(
        "tooltip--overflow-top",
        "tooltip--overflow-right",
        "tooltip--overflow-bottom",
        "tooltip--overflow-left"
      );
      tooltip.style.top    = "";
      tooltip.style.right  = "";
      tooltip.style.bottom = "";
      tooltip.style.left   = "";
    });
  }

  // -------------------------------------------------------------------------
  // Positioning
  // -------------------------------------------------------------------------

  positionHotspots() {
    if (!this.imageWrapper) return;
    const imageBounds = this.imageWrapper.getBoundingClientRect();

    this.points.forEach((point) => {
      const ySetting = parseInt(point.dataset.hotspotYAxis, 10) || 0;
      const xSetting = parseInt(point.dataset.hotspotXAxis, 10) || 0;
      const pointBounds = point.getBoundingClientRect();

      const yDifference = imageBounds.height - pointBounds.height;
      const yPercentage = (yDifference / imageBounds.height) * ySetting;
      point.style.bottom = `${yPercentage}%`;

      const xDifference = imageBounds.width - pointBounds.width;
      const xPercentage = (xDifference / imageBounds.width) * xSetting;
      point.style.left = `${xPercentage}%`;

      point.style.visibility = "visible";
    });
  }

  positionTooltips() {
    if (!this.imageWrapper) return;

    // Reset first since conditions (viewport, scroll) may have changed
    // since the tooltip last opened
    this._resetTooltips();

    const imageWrapperRightBound = this.imageWrapper.getBoundingClientRect().right;

    this.tooltips.forEach((tooltip) => {
      const bounds = tooltip.getBoundingClientRect();
      const style  = getComputedStyle(tooltip);

      const marginTop    = parseInt(style.marginTop, 10) || 0;
      const marginRight  = parseInt(style.marginRight, 10) || 0;
      const marginBottom = parseInt(style.marginBottom, 10) || 0;
      const marginLeft   = parseInt(style.marginLeft, 10) || 0;

      const topBounds    = bounds.top - marginTop;
      const rightBounds  = bounds.right + marginRight;
      const bottomBounds = bounds.bottom + marginBottom;
      const leftBounds   = bounds.left - marginLeft;

      if (rightBounds >= imageWrapperRightBound) {
        tooltip.classList.add("tooltip--overflow-right");
        tooltip.style.left = `${imageWrapperRightBound - rightBounds}px`;
      }

      if (leftBounds <= 0) {
        tooltip.classList.add("tooltip--overflow-left");
        tooltip.style.left = `${Math.abs(leftBounds)}px`;
      }

      if (topBounds <= 0) {
        // Tooltips are always positioned below the hotspot, so this
        // shouldn't normally trigger — kept as a defensive theme-specific case
        tooltip.classList.add("tooltip--overflow-top");
      }

      if (bottomBounds >= window.innerHeight) {
        tooltip.classList.add("tooltip--overflow-bottom");
        tooltip.style.top = `unset`;
        tooltip.style.bottom = `calc(100% + 12px)`;
        
      }
    });
  }

  // -------------------------------------------------------------------------
  // Listener tracking — lets onSectionUnload tear everything down in one call
  // -------------------------------------------------------------------------

  _on(el, event, listener) {
    if (!el || !event || !listener) return null;
    this._listeners.push({ el, event, listener });
    el.addEventListener(event, listener);
    return { el, event, listener };
  }

  _off({ el, event, listener } = {}) {
    if (!el || !event || !listener) return null;
    this._listeners = this._listeners.filter(
      (l) => el !== l.el || event !== l.event || listener !== l.listener
    );
    el.removeEventListener(event, listener);
    return { el, event, listener };
  }

  _offAll() {
    this._listeners.forEach(({ el, event, listener }) => el.removeEventListener(event, listener));
    this._listeners = [];
  }

  // -------------------------------------------------------------------------
  // Cleanup — runs automatically on disconnectedCallback
  // -------------------------------------------------------------------------

  onSectionUnload() {
    this._offAll();
  }
}

customElements.define("shoppable-image-element", ShoppableImage);